export default __webpack_public_path__ + "static/media/marker-blue-sky-red.50a02bdd.png";